/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_OrgInputs */

const th_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังโหลดองค์กร…`)
};

const en_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading organisation…`)
};

const ja_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`団体を読み込んでいます…`)
};

const zh_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载组织…`)
};

const es_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando organización…`)
};

const pt_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando organização…`)
};

const id_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat organisasi…`)
};

const fr_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement de l’organisation…`)
};

const tl_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nilo-load ang organisasyon…`)
};

const vi_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải tổ chức…`)
};

const ko_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`조직을 불러오는 중…`)
};

const de_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisation wird geladen…`)
};

const ru_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загружаем организацию…`)
};

const tr_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuruluş yükleniyor…`)
};

const it_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento organizzazione…`)
};

const pl_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wczytywanie organizacji…`)
};

const uk_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантажуємо організацію…`)
};

const hi_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संगठन लोड हो रहा है…`)
};

const ar_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ تحميل المؤسسة…`)
};

const ms_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat organisasi…`)
};

const bn_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সংস্থা লোড হচ্ছে…`)
};

const zh_tw2_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在載入組織…`)
};

const zh_hk2_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在載入組織…`)
};

const ur_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ادارہ لوڈ ہو رہا ہے…`)
};

const fa_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال بارگذاری سازمان…`)
};

const sw_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inapakia shirika…`)
};

const nl_loading_org = /** @type {(inputs: Loading_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisatie laden…`)
};

/**
* | output |
* | --- |
* | "Loading organisation…" |
*
* @param {Loading_OrgInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const loading_org = /** @type {((inputs?: Loading_OrgInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_OrgInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_loading_org(inputs)
	if (locale === "ja") return ja_loading_org(inputs)
	if (locale === "zh") return zh_loading_org(inputs)
	if (locale === "es") return es_loading_org(inputs)
	if (locale === "pt") return pt_loading_org(inputs)
	if (locale === "id") return id_loading_org(inputs)
	if (locale === "fr") return fr_loading_org(inputs)
	if (locale === "tl") return tl_loading_org(inputs)
	if (locale === "vi") return vi_loading_org(inputs)
	if (locale === "ko") return ko_loading_org(inputs)
	if (locale === "de") return de_loading_org(inputs)
	if (locale === "ru") return ru_loading_org(inputs)
	if (locale === "tr") return tr_loading_org(inputs)
	if (locale === "it") return it_loading_org(inputs)
	if (locale === "pl") return pl_loading_org(inputs)
	if (locale === "uk") return uk_loading_org(inputs)
	if (locale === "hi") return hi_loading_org(inputs)
	if (locale === "ar") return ar_loading_org(inputs)
	if (locale === "ms") return ms_loading_org(inputs)
	if (locale === "bn") return bn_loading_org(inputs)
	if (locale === "zh-TW") return zh_tw2_loading_org(inputs)
	if (locale === "zh-HK") return zh_hk2_loading_org(inputs)
	if (locale === "ur") return ur_loading_org(inputs)
	if (locale === "fa") return fa_loading_org(inputs)
	if (locale === "sw") return sw_loading_org(inputs)
	if (locale === "nl") return nl_loading_org(inputs)
	return en_loading_org(inputs)
});